<template>
  <div class="card">
    <div class="card-header d-flex align-items-center">
      <h5 class="mb-0">
        <slot />
      </h5>

      <div class="ml-auto" />

      <a-button
        class="ml-2"
        :disabled="loading"
        @click="list()"
      >
        <fa-icon
          :spin="loading"
          :icon="['fas','sync-alt']"
        />
      </a-button>
    </div>
    <div class="card-header d-block d-md-flex align-items-end bb-1">
      <div class="mb-3 mb-md-0">
        <small class="bold">Fechas:</small>
        <br>
        <a-range-picker
          v-model="dfilters.date"
          :disabled="loading"
          :placeholder="['Desde', 'Hasta']"
          :ranges="ranges"
        />
      </div>

      <div class="ml-auto d-none d-md-block" />

      <div class="ml-md-3 mb-3 mb-md-0">
        <small class="bold">Turnos:</small>
        <br>
        <a-select
          v-model="dfilters.turns"
          :disabled="loading"
          mode="multiple"
          allow-clear
          placeholder="Turnos"
          :style="{'min-width': '100px'}"
          class="w-100 w-md-auto"
        >
          <a-select-option
            v-for="(item,index) in filters.turns"
            :key="index"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </div>

      <div class="ml-md-3 mb-3 mb-md-0">
        <small class="bold">Grupos:</small>
        <br>
        <a-select
          v-model="dfilters.groups"
          mode="multiple"
          allow-clear
          :disabled="loading"
          placeholder="Grupos"
          :style="{'min-width': '100px'}"
          class="w-100 w-md-auto"
        >
          <a-select-option
            v-for="(item,index) in filters.groups"
            :key="index"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </div>

      <div class="ml-md-3 mb-3 mb-md-0">
        <small class="bold">Artículos:</small>
        <br>
        <a-select
          v-model="dfilters.articles"
          mode="multiple"
          allow-clear
          :disabled="loading"
          placeholder="Artículos"
          :style="{'min-width': '100px'}"
          class="w-100 w-md-auto"
        >
          <a-select-option
            v-for="(item,index) in filters.articles"
            :key="index"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </div>

      <div class="ml-md-3 mb-3 mb-md-0">
        <small class="bold">Operarios:</small>
        <br>
        <a-select
          v-model="dfilters.operators"
          mode="multiple"
          allow-clear
          :disabled="loading"
          placeholder="Operarios"
          :style="{'min-width': '100px'}"
          class="w-100 w-md-auto"
        >
          <a-select-option
            v-for="(item,index) in filters.operators"
            :key="index"
            :value="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </div>

      <a-button
        class="ml-md-3 d-inline-block"
        type="danger"
        :disabled="loading || !filtered"
        @click="clear()"
      >
        <fa-icon
          :sping="loading"
          :icon="['fas','eraser']"
          class="mr-2"
        /> Borrar
      </a-button>

      <div class="ml-2 d-inline-block">
        <a-button
          type="primary"
          :disabled="loading"
          @click="setFilters"
        >
          <fa-icon
            :icon="['fas', 'filter']"
            class="mr-2"
          /> Filtrar
        </a-button>
      </div>
    </div>

    <div class="card-body">
      <div v-if="loading">
        <g-caption
          :icon="['fas','chart-pie']"
          :size="['18px','42px']"
          :delay="0"
          animated="flip"
          infinite
        >
          <b class="text-uppercase">Cargando</b>
        </g-caption>
      </div>
      <div
        v-else-if="e404"
        class="text-center"
      >
        <img
          src="@/system/assets/images/public/empty.png"
          class="mb-2"
        >

        <h4 class="text-gray-6">
          No se encontraron resultados
        </h4>
      </div>
      <vue-c3
        v-show="!e404 && !loading"
        :handler="handler"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import VueC3 from 'vue-c3';
import 'c3/c3.min.css';

export default {
	components: {
		VueC3
	},
	props: {
		scope: {
			type: String,
			required: true
		},
		filters: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			handler: new Vue(),
			dfilters: {
				date: [this.$moment().subtract(31, 'days'), this.$moment()],
				turns: [],
				groups: [],
				articles: [],
				operators: []
			},
			ranges: {
				Hoy: [this.$moment(), this.$moment()],
				Ayer: [this.$moment().startOf(1, 'days'), this.$moment().subtract(1, 'days')],
				'Este mes': [this.$moment().startOf('month'), this.$moment()],
				'Esta semana': [this.$moment().startOf('week'), this.$moment()]
			},
			options: {
				data: {
					x: 'x',
					columns: []
				},
				axis: {
					y: {
						min: 0,
						max: 200,
						padding: { top: 0, bottom: 0 },
						tick: {
							format(d) { return `${d.toFixed(2)} %`; }
						}
					},
					x: {
						type: 'timeseries',
						tick: {
							fit: true,
							format: '%e %b %y'
						}
					}
				}
			},
			loaded: false,
			loading: false,
			e404: false
		};
	},
	computed: {
		filtered() {
			if (this.turns && this.turns.length > 0) return true;
			if (this.groups && this.groups.length > 0) return true;
			if (this.articles && this.articles.length > 0) return true;
			if (this.operators && this.operators.length > 0) return true;

			return false;
		},
		date: {
			get() {
				return this.$vault.get(`${this.scope}Stats_date`);
			},
			set(val) {
				return this.$vault.set(`${this.scope}Stats_date`, _.cloneDeep(val));
			}
		},
		turns: {
			get() {
				return this.$vault.get(`${this.scope}Stats_turns`);
			},
			set(val) {
				return this.$vault.set(`${this.scope}Stats_turns`, _.cloneDeep(val));
			}
		},
		groups: {
			get() {
				return this.$vault.get(`${this.scope}Stats_groups`);
			},
			set(val) {
				return this.$vault.set(`${this.scope}Stats_groups`, _.cloneDeep(val));
			}
		},
		articles: {
			get() {
				return this.$vault.get(`${this.scope}Stats_articles`);
			},
			set(val) {
				return this.$vault.set(`${this.scope}Stats_articles`, _.cloneDeep(val));
			}
		},
		operators: {
			get() {
				return this.$vault.get(`${this.scope}Stats_operators`);
			},
			set(val) {
				return this.$vault.set(`${this.scope}Stats_operators`, _.cloneDeep(val));
			}
		},
		data: {
			get() {
				return this.$vault.get(`${this.scope}Stats_data`);
			},
			set(val) {
				return this.$vault.set(`${this.scope}Stats_data`, _.cloneDeep(val));
			}
		}
	},
	created() {
		if (this.date) this.dfilters.date = this.date;
		if (this.turns) this.dfilters.turns = this.turns;
		if (this.groups) this.dfilters.groups = this.groups;
		if (this.articles) this.dfilters.articles = this.articles;
		if (this.operators) this.dfilters.operators = this.operators;
	},
	mounted() {
		if (this.data) {
			this.options.data.columns = this.data;
			this.handler.$emit('init', _.cloneDeep(this.options));
			this.loaded = true;
		} else {
			this.list();
		}
	},
	methods: {
		async list(refresh = false) {
			this.loading = true;
			this.e404 = false;

			if (!this.date) {
				this.date = [this.$moment().subtract(31, 'days'), this.$moment()];
				this.dfilters.date = this.date;
			}

			const params = {
				date: JSON.stringify([this.$moment(this.date[0]).format('YYYY-MM-DD'), this.$moment(this.date[1]).format('YYYY-MM-DD')]),
				turns: JSON.stringify(this.turns),
				groups: JSON.stringify(this.groups),
				articles: JSON.stringify(this.articles),
				operators: JSON.stringify(this.operators),
				refresh: refresh ? 1 : 0
			};

			const result = await this.$lambda.get(`stats/${this.scope}`, { params });

			this.loading = false;

			if (result.ok) {
				this.data = result.data.data;

				if (this.loaded) {
					this.handler.$emit('dispatch', (chart) => chart.load({ columns: this.data }));
				} else {
					this.options.data.columns = this.data;
					this.handler.$emit('init', this.options);
				}

				this.loaded = true;
			} else {
				this.e404 = true;
			}
		},
		setFilters() {
			this.date = this.dfilters.date;
			this.turns = this.dfilters.turns;
			this.groups = this.dfilters.groups;
			this.articles = this.dfilters.articles;
			this.operators = this.dfilters.operators;

			this.list();
		},
		clear() {
			this.date = [this.$moment().subtract(31, 'days'), this.$moment()];
			this.turns = [];
			this.groups = [];
			this.articles = [];
			this.operators = [];

			this.dfilters.date = this.date;
			this.dfilters.turns = this.turns;
			this.dfilters.groups = this.groups;
			this.dfilters.articles = this.articles;
			this.dfilters.operators = this.operators;
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
